import React from 'react';
import { Link } from 'react-router-dom';

const ThemeDetails = () => {
  return (
    <section className="relative min-h-screen overflow-hidden py-20 sm:py-28 lg:py-32 bg-slate-900">
      {/* Static Globe Sketch at Top Center */}
      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/3 z-20">
        <div className="relative w-80 h-80 sm:w-[28rem] sm:h-[28rem] lg:w-[32rem] lg:h-[32rem]">
          {/* Static Globe SVG */}
          <div className="w-full h-full transform scale-x-[-1]">
            <svg
              viewBox="0 0 500 500"
              className="w-full h-full"
              xmlns="http://www.w3.org/2000/svg"
            >
              {/* Main Globe Outline - Inverted U */}
              <path
                d="M 50 200 Q 250 400 450 200"
                fill="none"
                stroke="#a855f7"
                strokeWidth="2"
                opacity="0.8"
              />
              
              {/* Internal Horizontal Curves - Latitude Lines */}
              <path
                d="M 100 180 Q 250 350 400 180"
                fill="none"
                stroke="#c084fc"
                strokeWidth="1.5"
                opacity="0.7"
              />
              <path
                d="M 120 160 Q 250 300 380 160"
                fill="none"
                stroke="#818cf8"
                strokeWidth="1.5"
                opacity="0.7"
              />
              
              {/* Curved Vertical Lines - Longitudes with 3D Perspective */}
              <path
                d="M 100 200 Q 150 180 100 160"
                fill="none"
                stroke="#a855f7"
                strokeWidth="1.5"
                opacity="0.6"
              />
              <path
                d="M 150 200 Q 200 180 150 160"
                fill="none"
                stroke="#a855f7"
                strokeWidth="1.5"
                opacity="0.6"
              />
              <path
                d="M 250 200 L 250 400"
                fill="none"
                stroke="#a855f7"
                strokeWidth="1.5"
                opacity="0.6"
              />
              <path
                d="M 350 200 Q 300 180 350 160"
                fill="none"
                stroke="#a855f7"
                strokeWidth="1.5"
                opacity="0.6"
              />
              <path
                d="M 400 200 Q 350 180 400 160"
                fill="none"
                stroke="#a855f7"
                strokeWidth="1.5"
                opacity="0.6"
              />
            </svg>
          </div>
        </div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center min-h-[60vh] pt-16 sm:pt-20 lg:pt-24">
          
          {/* Left Column - Title */}
          <div className="space-y-6">
            {/* Purple dot */}
            <div className="w-3 h-3 bg-purple-600 rounded-full"></div>
            
            <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-AfacadFluxLight font-bold tracking-tight text-white leading-tight">
              A Virtual Golf Course for Founders
            </h2>
          </div>

          {/* Right Column - Content */}
          <div className="space-y-6">
            <div className="space-y-6 text-gray-300 font-AfacadFluxLight leading-relaxed">
              <p className="text-base sm:text-lg leading-relaxed">
                Have you ever had an idea, but was nervous where to start? With years of experience with multiple key markets of the world, we can handhold you from baby steps to sprint, in no time.
              </p>
              
              <p className="text-base sm:text-lg leading-relaxed">
                Do you have a puzzle with missing pieces which is holding you from starting your own business? Email us what you need or where you need help with. We will have our specialists and experts from around the world to help you with assembling the missing pieces.
              </p>
            </div>
            
            <div className="pt-4">
              <Link to="/contact" className="inline-block bg-gradient-to-r from-purple-600 to-indigo-600 text-white px-8 py-3 rounded-lg font-medium hover:from-purple-700 hover:to-indigo-700 transform hover:-translate-y-1 transition-all duration-300 shadow-lg hover:shadow-xl font-AfacadFluxLight uppercase tracking-wide text-sm text-center">
                GET STARTED
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Custom CSS for slow rotation */}
      <style jsx>{`
        @keyframes spin-slow {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
        
        @keyframes spin-slow-reverse {
          from {
            transform: rotate(360deg);
          }
          to {
            transform: rotate(0deg);
          }
        }
        
        @keyframes spin-3d {
          from {
            transform: perspective(1000px) rotateY(0deg) rotateX(15deg);
          }
          to {
            transform: perspective(1000px) rotateY(360deg) rotateX(15deg);
          }
        }
        
        .animate-spin-slow {
          animation: spin-slow 20s linear infinite;
        }
        
        .animate-spin-3d {
          animation: spin-3d 20s linear infinite;
        }
        
        .animate-spin-slow-reverse {
          animation: spin-slow-reverse 20s linear infinite;
        }
        
        @keyframes float {
          0%, 100% {
            transform: translateY(0px) scale(1);
          }
          50% {
            transform: translateY(-20px) scale(1.05);
          }
        }
        
        @keyframes float-slow {
          0%, 100% {
            transform: translateY(0px) scale(1);
          }
          50% {
            transform: translateY(-15px) scale(1.02);
          }
        }
        
        @keyframes float-reverse {
          0%, 100% {
            transform: translateY(0px) scale(1);
          }
          50% {
            transform: translateY(-25px) scale(0.98);
          }
        }
        
        .animate-float {
          animation: float 6s ease-in-out infinite;
        }
        
        .animate-float-slow {
          animation: float-slow 8s ease-in-out infinite;
        }
        
        .animate-float-reverse {
          animation: float-reverse 7s ease-in-out infinite;
        }
      `}</style>
    </section>
  );
};

export default ThemeDetails;


